<template>
  <div class="menu" dir="rtl">
    <div class="menu-item" v-for="item in menuList" :key="item.router">
      <button class="btn" @click="$router.push(item.router)" :class="{active:item.enName === activeMenu }">
        {{item.name}}
        <!-- <img v-if="item.name=='占楼宝'" style="position: absolute;margin-top: -18px;margin-left: -47px;z-index: 1;" src="../assets/image/zlbPercent50.png" /> -->
      </button>
    </div>
    <div style="position: absolute;left: 0;right: 0;">
<!--      <div class="menu-item bottom">-->
<!--        <button class="btn videomessage" :class="{active:`vedio` === activeMenu }" @click="$router.push(`/vedio`)">-->
<!--        </button>-->
<!--      </div>-->
      <div class="menu-item bottom">
        <button class="btn message" :class="{active:`message` === activeMenu }" @click="$router.push(`/message`)">
          <img src="../assets/image/new_ico.png" v-if="isNew===1">
        </button>
      </div>
      <!-- <div class="menu-item bottom">
        <button class="btn qq"
                onclick="window.location.href='tencent://Message/?Uin=1139447065&websiteName=q-zone.qq.com&Menu=yes'">
        </button>
      </div> -->
    </div>
  </div>
</template>


<script>
  class MenuModel {
    constructor(name, enName, router) {
      this.name = name;
      this.enName = enName;
      this.router = router;
    }
  }

  export default {
    componentName: "Menu",
    data() {
      let menuList =  [
          new MenuModel("SEO大数据", "seobigdata", "/seobigdata"),
          new MenuModel("查首页外链", "outlink", "/outlink"),
          new MenuModel("查网站排名词", "baidurank", "/baidurank"),
          new MenuModel("鼠标查排名词", "mousebaidurank", "/mousebaidurank"),
          new MenuModel("查No Follow", "nofollow", "/nofollow"),
          new MenuModel("查死链", "badlink", "/badlink"),
          new MenuModel("查百度收录", "baidusite", "/baidusite"),
          new MenuModel("查备案信息", "checkicp", "/checkicp")
        ];

      return {
        menuList
      }
    },
    computed: {
      activeMenu() {
        return this.$store.state.menu.name
      },
      isNew: {
        get() {
          return this.$store.state.message.isNew
        },
        set(val) {
          this.$store.state.message.isNew = val
        }
      },
      messageList: {
        get() {
          return this.$store.state.message.messageList
        },
        set(val) {
          this.$store.state.message.messageList = val
        }
      },
      rowcountnew:{
          get(){
              return this.$store.state.sofasniper.rowcountnew
          },
          set(val){
              this.$store.state.sofasniper.rowcountnew = val
          }
      }
    },
    mounted() {
      this.listen();
      this.isNew=parseInt(localStorage.getItem('message_isnew'));
      this.$messenger.addTarget(window.parent, 'parent');
      if(localStorage.getItem('_5118_ctivity_message'))
      {
        var datamessageobj=this.localstorageget('_5118_ctivity_message',1000*60*60*2);//过期时间为2小时
        if (datamessageobj!="" && datamessageobj!=null) {
          this.messageList=datamessageobj
        }
        else
        {
          this.$messenger.targets['parent'].send("Activity-5118-IsNew-Message");
        }
      }
      else
      {
         this.$messenger.targets['parent'].send("Activity-5118-IsNew-Message");
      }

    },
    methods: {
      listen() {
        this.$messenger.listen("_5118_Activity_Message_New", (msg = false) => {
          if(localStorage.getItem('message_isnew'))
          {
            let oldmsgnum=localStorage.getItem('message_isnew');
            if(oldmsgnum!=msg)
            {
              localStorage.setItem('message_isnew',msg);
              this.isNew = msg;
            }
            else
            {
              this.isNew=parseInt(localStorage.getItem('message_isnew'));
            }
          }
          else
          {
            localStorage.setItem('message_isnew',msg);
            this.isNew = msg;
          }

        });

        this.$messenger.listen("_5118_Activity_Message_Info", (msg = []) => {
          this.messageList = msg
          this.localstorageset('_5118_ctivity_message',msg);
        });

         this.$messenger.listen("_5118_Version_No", (msg = []) => {
            if(msg.replace(/\./gi, '')>200){
              for(let num in this.menuList)
              {
                if(this.menuList[num].name==='违规词查询' || this.menuList[num].name==='占楼宝')
                {
                  return
                }
              }
              this.menuList.push(new MenuModel("违规词查询", "prohibitedwords", "/prohibitedwords"))
              // this.menuList.push(new MenuModel("占楼宝", "sofasniper", "/sofasniper"))
            }
        });
      },
      //设置localstorage过期时间
      localstorageset(key,value){
          var curTime = new Date().getTime();
          localStorage.setItem(key,JSON.stringify({data:value,time:curTime}));
      },
      //获取localstorage过期时间
      localstorageget(key,exp){
          var data = localStorage.getItem(key);
          var dataObj = JSON.parse(data);
          if (new Date().getTime() - dataObj.time>exp) {
              console.log('信息已过期');
          }else{
              var dataObjDatatoJson = dataObj.data;
              return dataObjDatatoJson;
          }
      }
    }
  }
</script>

<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .menu {
    width: @menu-width;
    height: 100%;
    background-color: @menu-color;
    position: relative;
    overflow: auto;
    .menu-item {
      .btn {
        display: block;
        width: 100%;
        text-align: left;
        cursor: pointer;
        box-sizing: border-box;
        font-size: 12px;
        height: auto;
        color: white;
        background: none;
        line-height: 16px;
        border-radius: 0;
        padding: 8px 10px;
        border-image: initial;
        outline: none;
        transition: 0.3s;
        border-bottom: 1px solid rgba(204, 204, 204, 0.4);
        &.active, &:hover {
          background-color: @white;
          color: @theme-color;
        }
      }

      &.bottom {
        .btn {
          border-top: 1px solid rgba(204, 204, 204, 0.4);
          border-bottom: 0;

          &.message {
            height: 40px;
            width: 100%;
            background: url("../assets/image/btn-message.png") center no-repeat;
            &.active, &:hover {
              background: @white url("../assets/image/btn-message-blue.png") center no-repeat;
            }
          }
          &.videomessage {
            height: 40px;
            width: 100%;
            background: url("../assets/image/video.ico.png") center no-repeat;
            &.active, &:hover {
              background: @white url("../assets/image/video_hover.ico.png") center no-repeat;
            }
          }

          &.qq {
            height: 42px;
            width: 100%;
            background: url("../assets/image/btn-qq.png") center no-repeat;
            &.active, &:hover {
              background: @white url("../assets/image/btn-qq-blue.png") center no-repeat;
            }
          }

          img {
            position: relative;
            top: -13px;
            left: 25px;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue